import React,{useState} from 'react'
import Calendar from 'react-calendar';
import '../../common/Calendar.css'

function MiniCalendar({currentDate,changeDate}) {
    
     const onChange = date => changeDate(date)
     const tomorrow = new Date();
   tomorrow.setDate(tomorrow.getDate()); // Get tomorrow's date
  return (
    <>
    <Calendar 
        onChange={onChange} 
        value={currentDate} 
    />
    </>
  )
}

export default MiniCalendar